<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-nav-list>
					<ng-container *ngIf="Sys.User.currentUser?.hasRole(This.$Roles.Finance)"
						><mat-list-item
							mat-list-item
							class="has-click-handler"
							(click)="handler_NavigationItemBlock_74_click_toggleMenu_0($event, { $disabled: $disabled })"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'savings'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Finance toolbox' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
							<span matListItemMeta
								><mat-icon
									[innerHtml]="!screen.collapsedMenus.has('finance') ? 'expand_less' : 'expand_more'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
						</mat-list-item>
						<ng-container *ngIf="!screen.collapsedMenus.has('finance')"
							><a
								mat-list-item
								mat-list-item
								routerLink="/MatchTransactions"
								[queryParams]="{}"
								routerLinkActive="is-current-link"
								target="_self"
								[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
							>
								<span matListItemIcon
									><mat-icon
										[innerHtml]="'receipt'"
										fontSet="material-icons"
										[inline]="false"
									></mat-icon
								></span>
								<span matListItemTitle
									><span
										[innerHtml]="'Match Amex transactions' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></span>
							</a>

							<a
								mat-list-item
								mat-list-item
								routerLink="/CompanyNameLookup"
								[queryParams]="{}"
								routerLinkActive="is-current-link"
								target="_self"
								[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
							>
								<span matListItemIcon
									><mat-icon
										[innerHtml]="'search'"
										fontSet="material-icons"
										[inline]="false"
									></mat-icon
								></span>
								<span matListItemTitle
									><span
										[innerHtml]="'Match company names' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></span>
							</a>

							<a
								mat-list-item
								mat-list-item
								routerLink="/ManageMetadata"
								[queryParams]="{}"
								routerLinkActive="is-current-link"
								target="_self"
								[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
							>
								<span matListItemIcon
									><mat-icon
										[innerHtml]="'settings'"
										fontSet="material-icons"
										[inline]="false"
									></mat-icon
								></span>
								<span matListItemTitle
									><span
										[innerHtml]="'Manage metadata' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></span>
							</a>
						</ng-container>
					</ng-container>

					<mat-list-item
						mat-list-item
						class="has-click-handler"
						(click)="handler_NavigationItemBlock_60_click_toggleMenu_0($event, { $disabled: $disabled })"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'sports_score'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Personal development' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
						<span matListItemMeta
							><mat-icon
								[innerHtml]="!screen.collapsedMenus.has('goals') ? 'expand_less' : 'expand_more'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
					</mat-list-item>
					<ng-container *ngIf="!screen.collapsedMenus.has('goals')"
						><a
							mat-list-item
							mat-list-item
							routerLink="/GoalSettingHome"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'home'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Home' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<a
							mat-list-item
							mat-list-item
							routerLink="/GoalSettingsMine"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'self_improvement'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Mine' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<a
							mat-list-item
							mat-list-item
							routerLink="/GoalSettingsMyTeam"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'group'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'My team\'s' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<ng-container *ngIf="Sys.User.currentUser?.hasRole(This.$Roles.Hr)"
							><a
								mat-list-item
								mat-list-item
								routerLink="/GoalSettingsPerCycle"
								[queryParams]="{}"
								routerLinkActive="is-current-link"
								target="_self"
								[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
							>
								<span matListItemIcon
									><mat-icon
										[innerHtml]="'date_range'"
										fontSet="material-icons"
										[inline]="false"
									></mat-icon
								></span>
								<span matListItemTitle
									><span
										[innerHtml]="'For all employees' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></span>
							</a>
						</ng-container>
					</ng-container>
				</mat-nav-list>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
